<template>
  <span>
    <span v-show="readOnly">{{ value }}</span>
    <input v-show="!readOnly" v-model="inputValue" class="hidden-input" />
  </span>
</template>

<script>
export default {
  name: 'HiddenInput',
  props: {
    value: {},
    readOnly: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped>
.hidden-input {
  background: #ffffff17;
  border: none;
  border-bottom: 1px solid black;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  cursor: pointer;
  transition: background 0.3s ease-out;
}
.hidden-input:hover {
  background: #ffffff3a;
}
.hidden-input:focus {
  background: #ffffff3a;
}
</style>
